import React from 'react'
import { styled } from '@mui/material/styles';
import {Card, CardActions, IconButton, Collapse, Typography, CardContent, Avatar, CardHeader} from '@mui/material'

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const list = [
    {
        ques: 'เมนู My GPF & MY GPF Twins คืออะไร?',
        ans: [
            'เมนูช่วยให้สมาชิกวางแผนเกษียณ โดยการตั้งเป้าหมายเงินที่ต้องการใช้จ่ายหลังเกษียณ เพื่อนํามาประมาณการเงิน กบข. จากข้อมูลการออมเพิ่มและแผนการลงทุนปัจจุบัน และเปรียบเทียบกับ 2 Twins ของสมาชิกคือ Twin ที่ปรับตามใจสมาชิก กับ Twin ที่ กบข. ออกแบบทางเลือกให้ตามเป้าหมายที่ตั้งไว้'
        ]
    },
    {
        ques: 'ในหน้าแรกของแอป ยอดเงินที่ระบุตรง “เป้าหมายในวันเกษียณ” คืออะไร และคํานวณมาจากอะไร?',
        ans: [
            'ยอดเงินที่ระบุตรง “เป้าหมายในวันเกษียณ” เป็น ประมาณการเงิน กบข. ตามเป้าหมายที่สมาชิกตั้งไว้ โดยคํานวณจากแบบจําลองทางสถิติ และสมมติฐานอัตราเงินเฟ้อ 2.5% ต่อปี จนถึงปีที่สมาชิกเกษียณอายุ'
        ],
        img: [
            {
                src: 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset14.webp'
            }
        ]
    },
    {
        ques: 'My Twin 1 กับ My Twin 2 ต่างกันอย่างไร?',
        ans: [
            'My Twin 1 คือ ประมาณการเงิน กบข. จาก Twin ที่สมาชิกลองปรับ ได้ตามใจ โดยสมาชิกสามารถทดลองปรับอัตราการออมเพิ่ม และเลือกเปลี่ยนแผนการลงทุนได้เอง',
            'My Twin 2 คือ ประมาณการเงิน กบข. จาก Twin ที่ กบข. ออกแบบ ทางเลือกให้ ตามเป้าหมายที่สมาชิกตั้งไว้ และตามระดับความเสี่ยงจาก การลงทุนของสมาชิก',
            'สมาชิกสามารถเปรียบเทียบประมาณการเงิน กบข. ระหว่างตัวคุณใน ปัจจุบันกับ My Twin 1 ที่ลองปรับตามใจ กับ My Twin 2 ที่ กบข. ออกแบบทางเลือกให้'
        ],
        img: [
            {
                src: 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset15.webp'
            },
            {
                src: 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset16.webp'
            }
        ]
    },
    {
        ques: 'เมนูนี้เลือกอายุที่จะเกษียณเองได้หรือไม่?',
        ans: [
            'ไม่สามารถเลือกอายุเกษียณได้เอง เนื่องจากระบบจะคํานวณอายุเกษียณให้อัตโนมัติตามระเบียบข้อกําหนดการเกษียณอายุ ของแต่ละประเภทข้าราชการ ทั้งนี้ การปรับอายุเกษียณด้วยตนเองจะอยู่ในแผนพัฒนาบริการ กบข. ในลําดับถัดไป'
        ]
    },
    {
        ques: 'อยากแก้ไขเงินเป้าหมายที่ตั้งไว้หลังเกษียณในเมนูใหม่ ทําอย่างไร?',
        ans: [
            'สมาชิกสามารถปรับเปลี่ยนเงินเป้าหมายในวันเกษียณได้ โดยเข้าหน้าแรกของแอป จากนั้นกดที่ไอคอนรูป “ธง” และกดปุ่ม “ปรับเปลี่ยนเป้าหมาย” เพื่อแก้ไขตัวเลขที่ต้องการ'
        ],
        img: [
            {
                src: 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset17.webp'
            },
            {
                src: 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset18.webp'
            },
            {
                src: 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset19.webp'
            }
        ]
    },
    {
        ques: 'ประมาณการเงิน กบข. ที่แอปคํานวณให้จะได้ตอนเกษียณตามนี้หรือไม่?',
        ans: [
            'ยอดเงินที่แสดงในเมนูนี้เป็นยอดเงินประมาณการตามสมมติฐาน ซึ่งอาจจะไม่ใช่ยอดเงินที่สมาชิกได้รับจริง ณ วันเกษียณ เนื่องจาก เงิน กบข. ยังคงนําไปลงทุนทุกวันตามแผนการลงทุนที่สมาชิกเลือกจนถึงวันที่รับเงิน กบข. คืนจึงได้รับทราบยอดเงินที่แท้จริง'
        ]
    },
    {
        ques: 'ถ้าปรับการออมเพิ่มและเลือกแผนการลงทุนในเมนูนี้ จะกระทบกับยอดเงินในปัจจุบันหรือไม่?',
        ans: [
            'ไม่กระทบกับยอดเงินปัจจุบันของสมาชิกเป็นเพียงการทดลองปรับอัตราออมเพิ่มและทดลองเลือกแผนการลงทุน เพื่อดูประมาณการเงิน กบข. เท่านั้น'
        ]
    },
    {
        ques: 'My Twin 2 กบข. ออกแบบทางเลือกให้สมาชิกแต่ละคน คำนวณจากอะไร?',
        ans: [
            'กบข. ออกแบบ My Twin 2 ให้สมาชิกแต่ละคน โดยคำนวณจาก',
            '1) เป้าหมายวันเกษียณที่ตั้งไว้',
            '2) แผนการลงทุนตามระดับการยอมรับความเสี่ยงของสมาชิก',
            '3) อัตราออมเพิ่ม 1-27% โดยระบบจะคำนวณร่วมกับสมมติฐานต่าง ๆ กดอ่านที่นี่ โดยทางเลือกที่ กบข. ออกแบบให้ จะเป็นทางเลือกที่ได้ตามเป้าหมายที่สมาชิกตั้งไว้'
        ]
    },
    {
        ques: 'จำนวนเงินเป้าหมายที่กรอกจะต้องรวมเงินเฟ้อไปด้วยหรือไม่?',
        ans: [
            'ไม่ต้องรวมเงินเฟ้อ สมาชิกกรอกตัวเลขจำนวนเงินที่ต้องการใช้จ่ายวันเกษียณเป็นมูลค่าเงินปัจจุบัน จากนั้นระบบจะคำนวณจำนวนเงินรวมอัตราเงินเฟ้อเฉลี่ยปีละ 2.5% ให้โดยอัตโนมัติ'
        ]
    },
    {
        ques: 'ประมาณการเงิน กบข. ที่เปรียบเทียบกับเพื่อนสมาชิกใช้เกณฑ์อะไรบ้าง?',
        ans: [
            'เปรียบเทียบประมาณการเงิน กบข. ระหว่างตัวสมาชิกกับเพื่อนสมาชิก จาก 3 ปัจจัย คือ เป็นสมาชิก กบข. ปีเดียวกัน จะเกษียณปีเดียวกัน และมีเงินเดือนใกล้เคียงกับตัวสมาชิก'
        ]
    }
]

const Faq = ({width, appbarHeight}) => {
    const [expanded, setExpanded] = React.useState(0);
    const arrLength = list.length;
    const [elRefs, setElRefs] = React.useState([]);

    React.useEffect(() => {
    // add or remove refs
    setElRefs((elRefs) =>
        Array(arrLength)
        .fill()
        .map((_, i) => elRefs[i] || React.createRef()),
    );
    }, [arrLength]);

    return ( <div style={{paddingTop: 150}}>
       <h2 className='colorbase text-center mb-4'>คำถามที่พบบ่อย</h2>
       <div className='container'>
        {
            list.map((faqItem, itemIndex) => (
                <Card ref={elRefs[itemIndex]} key={'list' + itemIndex} sx={{cursor: 'pointer'}} className={itemIndex == 0 ? '' : 'mt-3'} onClick={() => window.scrollTo({ top: elRefs[itemIndex - 1].current.offsetTop - (window.innerHeight / 4), behavior: 'smooth' })}>
                 <CardActions disableSpacing onClick={() => setExpanded(itemIndex)}>
                     <Avatar sx={{ width: 30, height: 30 }} className='bg-lighting'>Q</Avatar>
                     <Typography variant='h6' className='pl-2 colorbase'>{faqItem.ques}</Typography>
                        <IconButton sx={{
                             marginLeft: 'auto'
                         }}>
                             {
                                 expanded == itemIndex ? (
                                     <ExpandLessIcon />
                                 ) : (
                                     <ExpandMoreIcon />
                                 )
                             }
                        </IconButton>
                     </CardActions>
                     <Collapse in={expanded == itemIndex ? true : false} timeout="auto" unmountOnExit>
                         <CardContent className='row p-3'>
                                <div className='col-md'>
                                    {
                                        faqItem.ans.map((ansItem, i) => (
                                            <Typography key={'anslist' + i} paragraph>
                                                {ansItem}
                                            </Typography>
                                        ))
                                    }
                                </div>
                                {
                                        faqItem.img != undefined && faqItem.img.length <= 2 && faqItem.img.map((imgItem, i) => (
                                            <div key={'img' + i} className={'col-md-' + (faqItem.img.length == 1 ? '5' : '3')}>
                                                {
                                                    imgItem.text != undefined && (
                                                        <h5 className='colorbase text-center'>{imgItem.text}</h5>
                                                    )
                                                }
                                                <img src={imgItem.src} width='100%' />
                                            </div>
                                        ))
                                    }
                                    {
                                        faqItem.img != undefined && faqItem.img.length === 3 && (
                                            <>
                                             <div className={'col-md-3 pr-0'}>
                                                <img src={faqItem.img[0].src} width='100%' />
                                            </div>
                                            <div className={'col-md-auto pl-0 pr-0' + (width < 800 ? ' text-center mb-3 pt-2' : ' pt-5')}>
                                                <img src={faqItem.img[1].src} width={(width < 750 ? '10%' : '40%')} style={{transform: (width < 750 ? 'rotate(90deg)' : 'rotate(0deg)')}} />
                                            </div>
                                            <div className={'col-md-3 pl-0'}>
                                                <img src={faqItem.img[2].src} width='100%' />
                                            </div>
                                            </>
                                        )
                                    }
                         </CardContent>
                     </Collapse>
                 </Card>
            ))
        }
       </div>
    </div> );
}
 
export default Faq;